// extracted by mini-css-extract-plugin
export default {"blogPostSection":"LearningSection_blogPostSection__KbQ4+","sectionTitle":"LearningSection_sectionTitle__prxRy"};